var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-message-container"},[_c('h3',{staticClass:"loading-message"},[_vm._v(_vm._s(_vm.loadingMessage)+_vm._s(_vm.loadingDots))])])
}
var staticRenderFns = []

export { render, staticRenderFns }